<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <ng-container *ngIf="!showNavigator">
                    <div (click)="showNavigator = true" class="wrap-img">
                        <img src="assets/images/icon-table.svg" alt="" />
                    </div>
                </ng-container>
                <import-navigator *ngIf="showNavigator" currentStep="cards" [showLastStep]="false"></import-navigator>
                <a routerLink="/cards" [queryParams]="{projectId: projectId}" [ngClass]="{'active':true, 'wrap-img':true}">
                    <img src="assets/images/icon-for-var.svg" alt="">
                </a>
            </div>
        </div>
    </div>
    <div [ngClass]="{ loading: loading, 'middle-part': true, 'middle-part_with-sidebar': true, 'analyze-variance': true }">
        <div *ngIf="model" class="sidebar" style="marginTop:34px">
            <div class="block block-top">
                <div class="block-navigation">
                    <a *ngIf="varianceModel && varianceModel.cards && varianceModel.cards.length" [href]="xlsxDownloadLink" target="_blank" class="icon-download">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 13 14" style="enable-background: new 0 0 13 14"
                            xml:space="preserve">
                            <style type="text/css">
                                .st0 {
                                    fill-rule: evenodd;
                                    clip-rule: evenodd;
                                    fill: #bfc0c2;
                                }
                            </style>
                            <path class="st0" d="M5.6,0h1.9c0.2,0,0.4,0.2,0.4,0.4v5.8h1.6l0,0l0.1,0c0.3,0,0.5,0.2,0.5,0.5C10,6.8,10,6.9,9.9,7l0,0L7,10.2
                          l-0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.2,0-0.4-0.1-0.5-0.3l0,0L3.3,7L3.2,7C3.1,6.9,3,6.8,3,6.6c0-0.3,0.2-0.5,0.5-0.5l0.1,0h1.6
                          V0.4C5.2,0.2,5.4,0,5.6,0z M0,9.6h1.8v2.7h9.6V9.6H13v3.6c0,0.4-0.4,0.8-0.8,0.8H0.8C0.4,14,0,13.6,0,13.2V9.6z" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
        <div class="main loading-bar__wrap" style="min-height: 400px;">
            <div *ngIf="model" class="tabs-block">
                <div [ngClass]="{'tabs-white': false, 'tabs': true}">
                    <div [ngClass]="{ 'active': selectedTabIx === undefined, 'tab': true }">
                        <div (click)="mainTabClick()" class="tab-wrap">
                            <a>
                                <b>
                                    Forecast walk
                                </b>
                            </a>
                        </div>
                    </div>
                    <div *ngFor="let tab of model.tabs; let tIx = index" [ngClass]="{ 'active': selectedTabIx === tIx, 'tab': true }">
                        <div (click)="tabClick(tIx)" class="tab-wrap">
                            <div [ngClass]="{'green-dot':tab.isMarkedCompatible}"></div>
                            <a class="no-underline" [title]="(tab.header ? tab.driverTypeName + ' / ' + tab.header : tab.driverTypeName)">
                                <b>{{ tab.driverTypeName }}</b>
                                <ng-container *ngIf="tab.header">&nbsp;/&nbsp;</ng-container>{{ tab.header }}
                                <span *ngIf="!tab.header">&nbsp;</span>
                            </a>
                            <div class="icons">
                                <a [routerLink]="['/benchmarks']"
                                    [queryParams]="{projectId: projectId, mainfcstwalk: true, tabIx: tIx}"
                                    [state]="{ tabIx: selectedTabIx }" title="Benchmarks" class="icon">
                                    <img src="assets/images/icon-tab-graph.svg" alt="">
                                </a>
                            </div>
                            <span (click)="closeTab(tIx)" class="close x-character"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="drivers-selection">
                <div *ngIf="false" class="drivers-selection_options">
                    <div class="view-type">
                        <a class="icon" (click)="setSeqMode(false)" *ngIf="seqMode">
                            <img src="assets/images/icon-seq.svg" alt="SEQ" />
                        </a>
                        <a class="icon" (click)="setSeqMode(true)" *ngIf="!seqMode">
                            <img src="assets/images/icon-tot.svg" alt="TOT" />
                        </a>
                        <help-link helpId="1"></help-link>
                    </div>
                </div>
                <div *ngIf="model" class="actions">
                    <a (click)="undo()" [ngClass]="{ disabled: !model.undoAvailable }" title="Undo">
                        <img src="assets/images/icon-back.svg" alt="Undo" />
                    </a>
                    <a (click)="redo()" [ngClass]="{ disabled: !model.redoAvailable }" title="Redo">
                        <img src="assets/images/icon-forward.svg" alt="Redo" />
                    </a>
                </div>
            </div>
            <div *ngIf="model && varianceModel">
                <div class="data-tiles container">
                    <div class="data-tiles_wrap">
                        <div class="block-outcome block-outcome_left">
                            <div class="wrap" [style.padding-top]="oldOutcomeTop + 'px'">
                                <div class="top">
                                    <div  class="value">
                                        <span [title]="varianceModel.oldTotalOutcome">{{ varianceModel.oldTotalOutcome | fancyNumber: totalOutcomeCtx }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom">
                                <div>Original forecast</div>
                            </div>
                        </div>
                        <div class="block-tiles">
                            <div class="data-statistic" [style.height]="blockHeight + 'px'">
                                <ng-container *ngFor="let item of waterfallItems; let i = index">
                                    <ng-container *ngIf="seqMode && showWaterfall">
                                        <div [style.margin-top]="item.seqTop + 'px'" [style.height]="item.seqHeight + 'px'" [style.background-color]="item.seqColor" class="data-rectangle"></div>
                                    </ng-container>
                                    <ng-container *ngIf="!seqMode && showWaterfall">
                                        <div class="data-rectangle_wrap">
                                            <div [style.margin-top]="item.seqTop + 'px'" [style.height]="item.seqHeight + 'px'" [style.background-color]="item.seqColor"
                                                class="data-rectangle with-shadow">
                                                <div [style.top]="item.absTop + 'px'" [style.height]="item.absHeight + 'px'" [style.background-color]="item.absColor" class="shadow"></div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <div *ngIf="i < varianceModel.cards.length && varianceModel.cards[i].subtotal" class="data-empty"></div>
                                </ng-container>
                            </div>
                            <div class="tiles">
                                <ng-container *ngFor="let card of varianceModel.cards; let i = index">
                                    <div [ngClass]="{ 'show-selected': card.isLocked, 'tile': true }">
                                        <div class="tile-wrap">
                                            <div class="state-block" *ngIf="!card.showAltView">
                                                <div class="block-view">
                                                    <div *ngIf="multiSelectMode == FcstCardsMultiSelectMode.None" class="actions-top">
                                                        <a *ngIf="card.cardType === FcstWalkCardType.Group" class="cursor-pointer visible">
                                                            <img src="assets/images/icon-layers.svg" alt="" />
                                                        </a>
                                                        <a *ngIf="card.cardType === FcstWalkCardType.Group" (click)="explodeCard(i, undefined)" title="Explode" class="cursor-pointer">
                                                            <img src="assets/images/icon-arrow-out.svg" alt="^" />
                                                        </a>
                                                        <a (click)="removeCard(card)" class="cursor-pointer">
                                                            <img src="assets/images/icon-cross.svg" alt="x" />
                                                        </a>
                                                        <a *ngIf="card.cardType === FcstWalkCardType.Group" (click)="collapseMult(card)" title="Collapse underlying multipliers" class="cursor-pointer">
                                                            <img src="assets/images/icon-arrow-layers-dark.svg" alt="" />
                                                        </a>
                                                        <a [routerLink]="['/benchmarks']"
                                                            [queryParams]="{projectId: projectId, mainfcstwalk: true, tabIx: selectedTabIx, cardIndex:i}"
                                                            [state]="{initSeqMode: seqMode }" class="cursor-pointer">
                                                            <img src="assets/images/icon-tab-graph.svg" alt="" />
                                                        </a>
                                                    </div>
                                                    <div *ngIf="multiSelectMode != FcstCardsMultiSelectMode.None" class="actions-top justify-center">
                                                        <a (click)="markForBulkCollapseClick(card)"
                                                            *ngIf="card.cardType == FcstWalkCardType.Group && (multiSelectMode == FcstCardsMultiSelectMode.Undecided || multiSelectMode == FcstCardsMultiSelectMode.Collapse)"
                                                            title="Collapse underlying multipliers" [ngClass]="{ 'icon-green':card.markedForBulkCollapse, 'cursor-pointer':true}">
                                                            <img src="assets/images/icon-arrow-layers-dark.svg" alt="+" />
                                                        </a>
                                                        <a (click)="markForBulkRemoveClick(card)" *ngIf="multiSelectMode == FcstCardsMultiSelectMode.Undecided || multiSelectMode == FcstCardsMultiSelectMode.Remove"
                                                            [ngClass]="{ 'icon-green':card.markedForBulkRemove, 'cursor-pointer':true}">
                                                            <img src="assets/images/icon-cross.svg" alt="x" />
                                                        </a>
                                                    </div>
                                                    <ng-container *ngIf="card.cardType === FcstWalkCardType.Precedent">
                                                        <div class="block-numbers">
                                                            <div class="variance-perc">
                                                                <span>Precedent</span>
                                                            </div>
                                                            <div *ngIf="card.driverName != 'New' && card.driverName != 'Lost'" class="variance-perc">
                                                                w/o forecast
                                                            </div>
                                                            <div *ngIf="card.driverName == 'New' || card.driverName == 'Lost'" class="variance-perc">
                                                                &nbsp;
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                    <ng-container *ngIf="card.cardType != FcstWalkCardType.Precedent && seqMode">
                                                        <div class="block-numbers">
                                                            <div [ngClass]="{ with_dot: card.seqDriverValue == card.absDriverValue, 'variance-abs': true }">
                                                                <span [title]="card.seqDriverValue" [ngClass]="{ with_dot: card.seqDriverValue == card.absDriverValue }">
                                                                    {{ card.seqDriverValue | fancyNumber: cardOutcomeCtx }}
                                                                </span>
                                                            </div>
                                                            <div class="variance-perc">
                                                                <ng-container *ngIf="card.driverName != model.outcomeName">
                                                                    <b>{{ card.driverName[0] }}</b><span>{{ card.altViewSeq.formCompPerc | fancyNumber: cardPercCtx }}%</span>
                                                                </ng-container>
                                                                <b>{{ model.outcomeName[0] }}</b><span>{{ 100 * (card.altViewSeq.outcomeNewVal - card.altViewSeq.outcomeOldVal) / card.altViewSeq.outcomeOldVal | fancyNumber: cardPercCtx }}%</span>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                    <ng-container *ngIf="card.cardType === FcstWalkCardType.Set && !seqMode">
                                                        <div class="block-numbers">
                                                            <div [title]="card.absDriverValue" [ngClass]="{ with_dot: card.seqDriverValue == card.absDriverValue, 'variance-abs': true }">
                                                                {{ card.absDriverValue | fancyNumber: cardOutcomeCtx }}
                                                            </div>
                                                            <div class="variance-perc">
                                                                <ng-container *ngIf="card.driverName != model.outcomeName">
                                                                    <b>{{ card.driverName[0] }}</b><span>{{ card.altViewTot.formCompPerc | fancyNumber: cardPercCtx }}%</span>
                                                                </ng-container>
                                                                <b>{{ model.outcomeName[0] }}</b><span>{{ card.absPercentValue | fancyNumber: cardPercCtx }}%</span>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                    <ul class="ellipses ellipses-root">
                                                        <li>
                                                            <div class="ellipse border-gray" [attr.content]="card.driverName" style="--background-color: white; --color: #7e7f7f;">
                                                                <b class="ellipse-text">{{ card.driverName }}</b>
                                                            </div>
                                                        </li>
                                                        <li *ngFor="let dimVal of card.dimensions | slice: 0:4">
                                                            <dimension-label [dimensionName]="dimVal" [showCreateSingleDimCardBtn]="false" [showRemoveBtn]="false"></dimension-label>
                                                        </li>
                                                        <li *ngIf="card.dimensions && card.dimensions.length == 5">
                                                            <dimension-label [dimensionName]="card.dimensions[4]" [showCreateSingleDimCardBtn]="false" [showRemoveBtn]="false"></dimension-label>
                                                        </li>
                                                        <li *ngIf="card.dimensions && card.dimensions.length > 5" class="with-dropdown">
                                                            <div class="ellipse" style="background-color: #f4efe2; color: #7e7f7f">
                                                                <b class="ellipse-text">{{ card.dimensions.length - 4 }} more</b>
                                                            </div>
                                                            <ul class="ellipses ellipses-dropdown">
                                                                <li *ngFor="let dimVal of card.dimensions | slice: 4">
                                                                    <dimension-label [dimensionName]="dimVal" [showCreateSingleDimCardBtn]="false" [showRemoveBtn]="false"></dimension-label>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                <div *ngIf="varianceModel.balanceCard" class="tile">
                                    <div class="tile-wrap">
                                        <div class="block-view">
                                            <div [title]="(seqMode ? varianceModel.balanceCard.seqValue : varianceModel.balanceCard.totValue)" class="variance-abs">{{ (seqMode ? varianceModel.balanceCard.seqValue : varianceModel.balanceCard.totValue) | fancyNumber: cardOutcomeCtx }}</div>
                                            <div class="variance-perc">&nbsp;</div>
                                            <ul class="ellipses ellipses-root">
                                                <li>
                                                    <div class="ellipse border-gray" [attr.content]="'Balance'" style="--background-color: white; --color: #7e7f7f">
                                                        <b class="ellipse-text">Balance</b>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div [ngClass]="{ 'block-outcome': true, 'block-outcome_right': true }">
                            <div class="wrap" [style.padding-top]="newOutcomeTop + 'px'">
                                <div class="top">
                                    <div class="value">
                                        <span [title]="varianceModel.newTotalOutcome">
                                            {{ varianceModel.newTotalOutcome | fancyNumber: totalOutcomeCtx }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom">
                                <div>Adjusted forecast</div>
                            </div>
                            <!-- <div class="bottom">
                                <div>Adjusted forecast</div>
                                <ng-container *ngIf="!showOutOfScope && outOfScopeCards && outOfScopeCards.length">
                                    <span>after</span>
                                    <ul class="ellipses ellipses-root">
                                        <li *ngFor="let drvTypeName of scopeDriverTypeNames | slice: 0:1">
                                            <div class="ellipse border-gray" [attr.content]="drvTypeName" style="--background-color: white; --color: #7e7f7f">
                                                <b class="ellipse-text">{{ drvTypeName }}</b>
                                            </div>
                                        </li>
                                        <li *ngIf="scopeDriverTypeNames.length == 2">
                                            <div class="ellipse border-gray" [attr.content]="scopeDriverTypeNames[1]" style="--background-color: white; --color: #7e7f7f">
                                                <b class="ellipse-text">{{ scopeDriverTypeNames[1] }}</b>
                                            </div>
                                        </li>
                                        <li *ngIf="scopeDriverTypeNames.length > 2" class="with-dropdown">
                                            <div class="ellipse" style="--background-color: white; --color: #7e7f7f">
                                                <b class="ellipse-text">{{ scopeDriverTypeNames.length - 1 }} more</b>
                                            </div>
                                            <ul class="ellipses ellipses-dropdown">
                                                <li *ngFor="let drvTypeName of scopeDriverTypeNames | slice: 1">
                                                    <div [attr.content]="drvTypeName" class="ellipse border-gray" style="--background-color: white; --color: #7e7f7f">
                                                        <b class="ellipse-text">{{ drvTypeName }}</b>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </ng-container>
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="data-tiles-bottom">
                    <div class="data-tiles-bottom__wrap">
                        <div class="tiles-depth">
                            <a (click)="toggleMultiSelect()" class="fcst-multi-select">
                                <img *ngIf="multiSelectMode == FcstCardsMultiSelectMode.None" src="assets/images/icon-multi-select-gray.svg" alt="" />
                                <img *ngIf="multiSelectMode != FcstCardsMultiSelectMode.None" src="assets/images/icon-multi-select-green.svg" alt="" />
                                <span>Multi-select</span>
                            </a>
                        </div>
                        <div *ngIf="multiSelectMode != FcstCardsMultiSelectMode.None" class="btn-group apply-depth-filters-buttons">
                            <br/>
                            <button (click)="applyBulkOperation()" class="btn btn-green btn-small" title="Apply bulk operation">Done</button>
                            <button (click)="turnOffMultiSelect()" class="btn btn-gray btn-small">Cancel</button>
                        </div>
                        <!-- <ul class="ellipses ellipses-root ellipses-inline ellipses-with_action">
                            <li *ngFor="let hier of legend">
                                <div class="ellipses-group">
                                    <div *ngFor="let item of hier.slice().reverse()" [ngClass]="{
                                            'show-selected': item.lockType != DimensionLockType.None,
                                            'hover-off': item.isSingleValue,
                                            'ellipses-group_ellipse': true
                                        }">
                                        <div class="ellipse" [style.--background-color]="item.bgColor" [style.--color]="item.fontColor" [attr.content]="item.name">
                                            <b class="ellipse-text">{{ item.name }}</b>
                                        </div>
                                        <div class="bottom-icons">
                                            <a *ngIf="item.lockType == DimensionLockType.Value && item.isSingleValue" class="icon-lock selected">
                                                <img src="assets/images/icon-lock_closed.svg" alt="locked" />
                                            </a>
                                            <div *ngIf="!item.isSingleValue" class="block-inline-icons">
                                                <a (click)="setDimLock(item.index, DimensionLockType.Value)" class="icon-lock" [ngClass]="{'selected': (item.lockType == DimensionLockType.Value)}">
                                                    <img src="assets/images/icon-lock_closed.svg" alt="lock" />
                                                </a>
                                                <a (click)="setDimLock(item.index, DimensionLockType.None)" class="icon-lock" [ngClass]="{'selected': (item.lockType == DimensionLockType.None)}">
                                                    <img src="assets/images/icon-lock_open.svg" alt="unlock" />
                                                </a>
                                                <a (click)="setDimLock(item.index, DimensionLockType.All)" class="icon-cross" [ngClass]="{'selected': (item.lockType == DimensionLockType.All)}">
                                                    <img src="assets/images/icon-cross.svg" alt="x" />
                                                </a>
                                                <a>
                                                    <help-link helpId="10"></help-link>
                                                </a>
                                            </div>
                                            <a *ngIf="item.isInFilter || item.isSingleValue" class="filter">
                                                <img *ngIf="item.isInFilter" src="assets/images/icon-filter.svg" alt="" />
                                                <span *ngIf="item.isSingleValue">1</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul> -->
                    </div>

                </div>
                <!-- <div (click)="quillClick($event)">
                    <quill-editor [(ngModel)]="story" format="html" [modules]="quillModules" (onBlur)="quillBlur($event)"></quill-editor>
                    <br/>
                </div> -->
            </div>
        </div>
    </div>
</main>
